/* eslint-disable no-plusplus */
/* eslint-disable react/button-has-type */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-unused-vars */
/* eslint-disable react/no-unknown-property */
/* eslint-disable max-len */
/* eslint-disable react/style-prop-object */

import React, { useContext } from 'react';
import { motion } from 'framer-motion';
import moment from 'moment';
import { PriceHandler } from '../../redux/helper/CamelCase';
import HeaderContext from '../../Components/Context/HeaderContext';

function CreditDebitListing({
    creditDebitList,
}) {
    const {
        isPopup,
        setisPopup,
        ErrorMessage,
        SetErrorMessage,
        SuccessMessage,
        SetSuccessMessage,
        colorValue,
        setcolorValue,
    } = useContext(HeaderContext);

    const handleViewDocument = (creditDebitUrl) => {
        if (creditDebitUrl) {
            window.open(creditDebitUrl, '_blank');
        }
    };

    const renderCreditDebitLink = (item) => {
        if (!item?.CREDIT_DEBIT_LINK) {
            return '-';
        }

        if (item?.credit_debit_url) {
            return (
                <button
                    type="button"
                    className="text-[#1976D2] underline cursor-pointer"
                    onClick={() => handleViewDocument(item?.credit_debit_url)}
                >
                    {item?.CREDIT_DEBIT_LINK}
                </button>
            );
        }

        return (
            <span
                className="text-[#090406] cursor-default"
                title="No file uploaded"
            >
                {item?.CREDIT_DEBIT_LINK}
            </span>
        );
    };

    return (
        <div>
            <div
                className="overflow-auto dropdown-menu relative z-10"
                style={{ maxHeight: 'calc(100vh - 298px)' }}
            >
                <table className="w-full table-auto relative">
                    <thead className="sticky top-0 left-0 z-[2]">
                        <tr className="bg-[#555259] h-10">
                            <th className="py-[5px] px-6 rounded-bl-lg rounded-tl-lg min-w-[180px] sticky top-0 left-0 bg-[#555259] z-[3]" scope="col">
                                <span className="text-sm29 font-bold text-[#FFFFFF]">
                                    Credit Debit Link
                                </span>
                            </th>
                            <th scope="col" className="py-[5px] px-7 min-w-[150px]">
                                <span className="text-sm29 font-bold text-[#FFFFFF] flex items-center justify-center">
                                    Document Type
                                </span>
                            </th>
                            <th scope="col" className="py-[5px] px-7 min-w-[180px]">
                                <span className="text-sm29 font-bold text-[#FFFFFF] flex items-center justify-center">
                                    Transaction Type
                                </span>
                            </th>
                            <th scope="col" className="py-[5px] px-7 min-w-[140px]">
                                <span className="text-sm29 font-bold text-[#FFFFFF] flex items-center justify-center">
                                    AR No
                                </span>
                            </th>
                            <th scope="col" className="py-[5px] px-7 min-w-[180px] text-center">
                                <span className="text-sm29 font-bold text-[#FFFFFF] flex items-center justify-center">
                                    AR Date
                                </span>
                            </th>
                            <th scope="col" className="py-[5px] px-7 min-w-[180px]">
                                <span className="text-sm29 font-bold text-[#FFFFFF] flex items-center justify-center">
                                    Document Number
                                </span>
                            </th>
                            <th scope="col" className="py-[5px] px-7 min-w-[180px]">
                                <span className="text-sm29 font-bold text-[#FFFFFF] flex items-center justify-center">
                                    Document Date
                                </span>
                            </th>
                            <th scope="col" className="py-[5px] px-7 min-w-[250px]">
                                <span className="text-sm29 font-bold text-[#FFFFFF] flex items-center justify-center">
                                    Narration
                                </span>
                            </th>
                            <th scope="col" className="py-[5px] px-7 min-w-[160px]">
                                <span className="text-sm29 font-bold text-[#FFFFFF] flex items-center justify-end">
                                    Total Taxable Value
                                </span>
                            </th>
                            <th scope="col" className="py-[5px] px-7 min-w-[140px]">
                                <span className="text-sm29 font-bold text-[#FFFFFF] flex items-center justify-end">
                                    Total Value
                                </span>
                            </th>
                            <th scope="col" className="py-[5px] px-7 min-w-[140px]">
                                <span className="text-sm29 font-bold text-[#FFFFFF] flex items-center justify-center">
                                    Org Code
                                </span>
                            </th>
                            <th scope="col" className="py-[5px] px-7 min-w-[120px]">
                                <span className="text-sm29 font-bold text-[#FFFFFF] flex items-center justify-center">
                                    Currency
                                </span>
                            </th>
                            <th scope="col" className="rounded-tr-lg rounded-br-lg py-[5px] px-7 min-w-[220px]">
                                <span className="text-sm29 font-bold text-[#FFFFFF] flex items-center justify-center">
                                    Reason For Issuing Document
                                </span>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {creditDebitList.length > 0 && creditDebitList.map((item, i) => (
                            <tr className="bg-[#FFFFFF] border-b border-[#DFEAF7]" key={`credit-debit-${i}`}>
                                <td
                                    className="text-sm font-normal text-[#090406] py-3 px-7 sticky left-0 z-[1]"
                                    style={{
                                        background: 'rgba(255, 255, 255, 0.95)',
                                        backdropFilter: 'blur(5.5px)',
                                    }}
                                >
                                    {renderCreditDebitLink(item)}
                                </td>
                                <td className="text-sm font-normal text-[#090406] py-3 px-7 text-center">
                                    {item?.DOCUMENT_TYPE || '-'}
                                </td>
                                <td className="text-sm font-normal text-[#090406] py-3 px-7 text-center">
                                    {item?.TRANSACTION_TYPE || '-'}
                                </td>
                                <td className="text-sm font-normal text-[#090406] py-3 px-7 text-center">
                                    {item?.AR_NO || '-'}
                                </td>
                                <td className="text-sm font-normal text-[#090406] py-3 px-7 text-center">
                                    {item?.AR_DATE ? moment(item?.AR_DATE, 'ddd, DD MMM YYYY HH:mm:ss [GMT]').format('ddd, DD MMM YYYY') : '-'}
                                </td>
                                <td className="text-sm font-normal text-[#090406] py-3 px-7 text-center">
                                    {item?.DOCUMENT_NUMBER || '-'}
                                </td>
                                <td className="text-sm font-normal text-[#090406] py-3 px-7 text-center">
                                    {item?.DOCUMENT_DATE ? moment(item?.DOCUMENT_DATE, 'ddd, DD MMM YYYY HH:mm:ss [GMT]').format('ddd, DD MMM YYYY') : '-'}
                                </td>
                                <td className="text-sm font-normal text-[#090406] py-3 px-7 text-center max-w-[250px] truncate" title={item?.NARRATION}>
                                    {item?.NARRATION || '-'}
                                </td>
                                <td className="text-sm font-normal text-[#090406] py-3 px-7 text-end">
                                    {item?.TOTAL_TAXABLE_VALUE !== null && item?.TOTAL_TAXABLE_VALUE !== undefined ? PriceHandler(item?.TOTAL_TAXABLE_VALUE) : '-'}
                                </td>
                                <td className="text-sm font-normal text-[#090406] py-3 px-7 text-end">
                                    {item?.TOTAL_VALUE !== null && item?.TOTAL_VALUE !== undefined ? PriceHandler(item?.TOTAL_VALUE) : '-'}
                                </td>
                                <td className="text-sm font-normal text-[#090406] py-3 px-7 text-center">
                                    {item?.ORG_CODE || '-'}
                                </td>
                                <td className="text-sm font-normal text-[#090406] py-3 px-7 text-center">
                                    {item?.CURRENCY || '-'}
                                </td>
                                <td className="text-sm font-normal text-[#090406] py-3 px-7 text-center">
                                    {item?.REASON_FOR_ISSUING_DOCUMENT || '-'}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default CreditDebitListing;

